import { render, staticRenderFns } from "./ItemSupplierDialog.vue?vue&type=template&id=47a4039d&lang=pug"
import script from "./ItemSupplierDialog.vue?vue&type=script&lang=js"
export * from "./ItemSupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports